import { useState, useRef, useEffect } from 'react'
import './EmojiPicker.css'

const EMOJIS = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😜',
  '🤪', '😎', '🤩', '🥳', '😏', '😢', '😭', '😡',
  '👍', '👎', '👏', '🙌', '🤝', '🙏', '💪', '✌️',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💔',
  '🔥', '✨', '🎉', '🎊', '🎈', '🎁', '💯', '👀',
  '🤔', '😴', '🥱', '😅', '😳', '😱', '🥰', '😋',
  '👋', '🫶', '💖', '⭐', '✅', '❌', '❓', '❗',
]

export default function EmojiPicker({ onSelect }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('touchstart', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('touchstart', handleClick)
    }
  }, [])

  return (
    <div className="emoji-picker" ref={ref}>
      <button
        type="button"
        className="emoji-toggle"
        onClick={() => setOpen(o => !o)}
        aria-label="Emojis"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <line x1="9" y1="9" x2="9.01" y2="9" />
          <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
      </button>
      {open && (
        <div className="emoji-grid">
          {EMOJIS.map(e => (
            <button
              key={e}
              type="button"
              className="emoji-item"
              onClick={() => onSelect(e)}
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
